import React from "react";
import { Check, CircleCheck } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Styling
import "./Assets/styles/pricingpage-styles.css";

// Images
import img_logo from "./Assets/images/logo.png";

const PricingPage = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className="pricingpage">
      <header className="header">
        <div className="container">
          <div className={classes.navbar_start}>
            <div className="logo">
              <Link to="/">
                <img src={img_logo} alt="" />
              </Link>
            </div>
            <Link to="/pricing" className={classes.navLink}>
              {t('pricingPage.pricing')}
            </Link>
          </div>
          <Link className="btn_design" to="/login">
            {t('auth.login')}
          </Link>
        </div>
      </header>
      <div className="container py-5">
        <div className="text-center mb-5">
          <h1 className="fs-1 mb-4 mt-5">{t('pricingPage.heroTitle')}</h1>
          <p className="text-muted">{t('pricingPage.heroSubtitle')}</p>
        </div>
        <div className="row g-4 justify-content-center">
          {/* Pricing Tier 1 */}
          <div className="col-md-4">
            <div className="card">
              <div className="card-body d-flex flex-column text-start">
                <h5 className="card-title">{t('pricingPage.tierTryoutTitle')}</h5>
                <p className="card-subtitle text-muted mt-2">{t('pricingPage.tierTryoutSubtitle')}</p>
                <h2 className="my-3 fs-4">{t('pricingPage.tierTryoutPrice')}</h2>
                {/* divider */}
                <div className="divider mb-3" />
                <p className="mb-2">{t('pricingPage.whatsIncluded')}</p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />{t('pricingPage.feature1Project')}
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />{t('pricingPage.feature1Company')}
                  </li>
                  <li className="mb-3 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />{t('pricingPage.feature3MonthAccess')}
                  </li>
                </ul>
                <div className="divider mb-3" />
                <ul className="list-unstyled mb-4">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    {t('pricingPage.featureTraining')}
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    {t('pricingPage.featureMoneyBack')}
                  </li>
                </ul>
                <Link className="btn_design_secondary mt-auto" to="/bookdemo">
                  {t('pricingPage.tellMeMore')}
                </Link>
              </div>
            </div>
          </div>

          {/* Pricing Tier 2 */}
          <div className="col-md-4">
            <div className="card">
              <div className="card-body d-flex flex-column text-start">
                <h5 className="card-title">{t('pricingPage.tierProfessionalTitle')}</h5>
                <p className="card-subtitle text-muted mt-2">{t('pricingPage.tierProfessionalSubtitle')}</p>
                <h2 className="my-3 fs-4">{t('pricingPage.tierProfessionalPrice')}</h2>
                <div className="divider mb-3" />
                <p className="mb-2">{t('pricingPage.whatsIncluded')}</p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />{t('pricingPage.feature3Projects')}
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />{t('pricingPage.feature1Company')}
                  </li>
                  <li className="mb-3 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    {t('pricingPage.featureLimitedSimulations')}
                  </li>
                </ul>
                <div className="divider mb-3" />
                <ul className="list-unstyled mb-4">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    {t('pricingPage.featureTraining')}
                  </li>
                </ul>
                <Link className="btn_design_secondary mt-auto" to="/bookdemo">
                  {t('pricingPage.tellMeMore')}
                </Link>
              </div>
            </div>
          </div>

          {/* Pricing Tier 3 */}
          <div className="col-md-4">
            <div className="card">
              <div className="card-body d-flex flex-column text-start">
                <h5 className="card-title">{t('pricingPage.tierEnterpriseTitle')}</h5>
                <p className="card-subtitle text-muted mt-2">{t('pricingPage.tierEnterpriseSubtitle')}</p>
                <h2 className="my-3 fs-4">{t('pricingPage.tierEnterprisePrice')}</h2>
                <div className="divider mb-3" />
                <p className="mb-2">{t('pricingPage.whatsIncluded')}</p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    {t('pricingPage.featureUnlimitedProjects')}
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    {t('pricingPage.featureUnlimitedCompanies')}
                  </li>
                  <li className="mb-3 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    {t('pricingPage.featureAdvancedSimulations')}
                  </li>
                </ul>
                <div className="divider mb-3" />
                <ul className="list-unstyled mb-4">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    {t('pricingPage.featureOnboarding')}
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    {t('pricingPage.featureStrategicSupport')}
                  </li>
                </ul>
                <Link className="btn_design_secondary mt-auto" to="/bookdemo">
                  {t('pricingPage.tellMeMore')}
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="cta-block text-center max-w-600">
          <h2 className="fs-3">{t('pricingPage.ctaTitle')}</h2>
          <p className="text-muted mt-3">{t('pricingPage.ctaText')}</p>
          <Link className="btn_design mt-4" to="/bookdemo">
            {t('pricingPage.tellMeMore')}
          </Link>
        </div>
      </div>
      <footer className="footer">
        <div className="container">
          <p>
            © 2025 <Link to="/"> Taplr </Link>. All rights reserved. Taplr is a product by Flagstone BV, Stedestraat 51, 8530 Harelbeke - Belgium. <Link to="/privacypolicy">{t('pricingPage.privacyPolicy')}</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#231F20",
    paddingTop: "65px",

    [theme.breakpoints.down("lg")]: {
      paddingTop: "20px",
    },
  },

  container: {
    maxWidth: "1560px",

    margin: "0 auto",
    padding: "0 15px",
    boxSizing: "border-box",
  },

  navbar_start: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "48px",
    padding: "0 15px",
    boxSizing: "border-box",
    height: "100%",
    [theme.breakpoints.down("lg")]: {
      padding: "0 10px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 5px",
    },
  },

  navLink: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "500",
    textDecoration: "none",
    padding: "0 15px",
    boxSizing: "border-box",
    "&:hover": {
      color: "#fff",
      textDecoration: "underline",
    },
  },

  row: {
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },

  col5: {
    flex: "0 0 41.666%",
    maxWidth: "41.666%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  col6: {
    flex: "0 0 50%",
    maxWidth: "50%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  col7: {
    flex: "0 0 58.333%",
    maxWidth: "58.333%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  logo: {
    // image inside
    "& img": {
      [theme.breakpoints.down("md")]: {
        width: "130px",
      },

      [theme.breakpoints.down("sm")]: {
        width: "118px",
      },
    },
  },

  banner: {
    padding: "30px 0 110px",
    backgroundColor: "#231F20",
    boxSizing: "border-box",

    [theme.breakpoints.down("lg")]: {
      padding: "30px 0 70px",
    },

    [theme.breakpoints.down("md")]: {
      padding: "0px 0 70px",
      marginTop: "-1px",
    },
  },
}));

export default PricingPage;
